module.exports = __webpack_public_path__ + "static/media/Terms_Conditions_English.9840b3d7.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Terms_Conditions_English.pdf
// module id = 1504
// module chunks = 0